import type { PointReason } from "@nifgash/shared/types";
import { api } from "./client";

export type PointTransaction = {
  id: string;
  amount: number;
  reason: PointReason;
  reference_id: string | null;
  created_at: string;
};

export type PointsPayload = {
  balance: number;
  transactions: PointTransaction[];
};

export async function getPoints(): Promise<PointsPayload> {
  return api<PointsPayload>("/api/points");
}

export type ReferralStats = {
  total: number;
  active: number;
  items: Array<{
    id: string;
    referee_user_id: string;
    status: "joined" | "active";
    joined_at: string;
    active_at: string | null;
  }>;
};

export type ReferralPayload = {
  link: string;
  stats: ReferralStats;
};

export async function getReferral(): Promise<ReferralPayload> {
  return api<ReferralPayload>("/api/referral");
}

/** Attribute the current (new) user to a referrer captured from a ?ref= link. */
export async function applyReferral(ref: string): Promise<{ applied: boolean }> {
  return api<{ applied: boolean }>("/api/referral/apply", {
    method: "POST",
    body: JSON.stringify({ ref }),
  });
}
